// Grup Xaluca content data — hotels, experiences, gastronomy, testimonials.

export const HOTELS = [
  {
    slug: "kasbah-hotel-xaluca-arfoud",
    category: "hotel",
    name: "Kasbah Hotel Xaluca Arfoud",
    location: "Arfoud",
    region: "Gateway to the Desert",
    region_fr: "La porte du désert",
    region_es: "Puerta del desierto",
    image:
      "https://customer-assets.emergentagent.com/job_xaluca-luxury/artifacts/6pvzp897_Kasbah%20Hotel%20Xaluca%20-%20Ae%CC%81reas%20-%20HamidBabni-1.jpg",
    gallery: [
      "https://customer-assets.emergentagent.com/job_xaluca-luxury/artifacts/6pvzp897_Kasbah%20Hotel%20Xaluca%20-%20Ae%CC%81reas%20-%20HamidBabni-1.jpg",
      "https://customer-assets.emergentagent.com/job_xaluca-luxury/artifacts/4p3qhcbe_Kasbah%20Hotel%20Xaluca%20-%20Ae%CC%81reas%20-%20HamidBabni-3.jpg",
      "https://customer-assets.emergentagent.com/job_xaluca-luxury/artifacts/htd6p1fu_Kasbah%20Hotel%20Xaluca%20-%20Ae%CC%81reas%20-%20HamidBabni-4.jpg",
      "https://customer-assets.emergentagent.com/job_xaluca-luxury/artifacts/qrtoq576_Kasbah%20Hotel%20Xaluca%20-%20Ae%CC%81reas%20-%20HamidBabni-5.jpg",
      "https://customer-assets.emergentagent.com/job_xaluca-luxury/artifacts/it6ekinq_Kasbah%20Hotel%20Xaluca%20-%20Ae%CC%81reas%20-%20HamidBabni-2.jpg",
    ],
    intro: {
      en: "Six kilometres from the city of Arfoud, the gateway to the Sahara. A fortified kasbah where adventure begins.",
      fr: "À six kilomètres d'Arfoud, la porte du Sahara. Une kasbah fortifiée où l'aventure commence.",
      es: "A seis kilómetros de Arfoud, la puerta del Sáhara. Una kasbah fortificada donde comienza la aventura.",
    },
    amenities: ["Pool", "Spa", "Restaurant", "Desert excursions", "Conference rooms"],
  },
  {
    slug: "kasbah-hotel-tombouctou",
    category: "hotel",
    name: "Kasbah Hotel Tombouctou",
    location: "Erg Chebbi · Merzouga",
    region: "Heart of the Erg Chebbi",
    region_fr: "Au cœur de l'Erg Chebbi",
    region_es: "En el corazón del Erg Chebbi",
    image:
      "https://images.unsplash.com/photo-1539020140153-e479b8c22e70?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1539020140153-e479b8c22e70?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80",
      "https://images.pexels.com/photos/30374217/pexels-photo-30374217.jpeg?auto=compress&cs=tinysrgb&w=1600",
      "https://images.pexels.com/photos/35771005/pexels-photo-35771005.jpeg?auto=compress&cs=tinysrgb&w=1600",
    ],
    intro: {
      en: "An oasis of comfort in the heart of the desert. Slow down, breathe, and let the dunes speak.",
      fr: "Une oasis de confort au cœur du désert. Ralentissez, respirez, laissez les dunes parler.",
      es: "Un oasis de confort en el corazón del desierto. Ralentiza, respira y deja que las dunas hablen.",
    },
    amenities: ["Pool", "Hammam", "Restaurant", "Camel rides", "Stargazing"],
  },
  {
    slug: "hotel-xaluca-dades",
    category: "hotel",
    name: "Hotel Xaluca Dades",
    location: "Boumalne Dades · Ouarzazate",
    region: "Between Valleys and Atlas Peaks",
    region_fr: "Entre vallées et sommets de l'Atlas",
    region_es: "Entre valles y cumbres del Atlas",
    image:
      "https://static.prod-images.emergentagent.com/jobs/4e06df6f-9a63-48ff-b8e2-384249cc96cb/images/3ef3804f701debb6deb08b44c397ef614c4c4d52fd2e912b5f5cbb24b2b0703e.png",
    gallery: [
      "https://static.prod-images.emergentagent.com/jobs/4e06df6f-9a63-48ff-b8e2-384249cc96cb/images/3ef3804f701debb6deb08b44c397ef614c4c4d52fd2e912b5f5cbb24b2b0703e.png",
      "https://images.unsplash.com/photo-1570133435536-7ececf000ef6?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80",
    ],
    intro: {
      en: "A dream made real between the rugged peaks of the Atlas and the silence of the high valleys.",
      fr: "Un rêve devenu réel entre les pics escarpés de l'Atlas et le silence des hautes vallées.",
      es: "Un sueño hecho realidad entre los picos escarpados del Atlas y el silencio de los valles altos.",
    },
    amenities: ["Mountain views", "Pool", "Restaurant", "Hiking guides", "Spa"],
  },
  {
    slug: "bivouacs-xaluca",
    category: "bivouac",
    bookable: false, // category page only — not a specific bookable property
    name: "Bivouacs Xaluca",
    location: "Erg Chebbi · Merzouga",
    region: "The Great Sea of Dunes",
    region_fr: "La grande mer de dunes",
    region_es: "El gran mar de dunas",
    image:
      "https://images.pexels.com/photos/30374217/pexels-photo-30374217.jpeg?auto=compress&cs=tinysrgb&w=1600",
    gallery: [
      "https://images.pexels.com/photos/30374217/pexels-photo-30374217.jpeg?auto=compress&cs=tinysrgb&w=1600",
      "https://images.pexels.com/photos/35771005/pexels-photo-35771005.jpeg?auto=compress&cs=tinysrgb&w=1600",
    ],
    intro: {
      en: "Camel-hair haimas in the heart of Erg Chebbi. Sleep beneath an infinite sky as the nomads do.",
      fr: "Des haimas en poil de chameau au cœur de l'Erg Chebbi. Dormez sous un ciel infini comme les nomades.",
      es: "Haimas de pelo de camello en el corazón del Erg Chebbi. Duerma bajo un cielo infinito como los nómadas.",
    },
    amenities: ["Private haimas", "Sunset dinner", "Berber music", "Sandboarding", "Camel trek"],
  },
  {
    slug: "hotel-riad-xaluca",
    category: "hotel",
    name: "Hotel Riad Xaluca",
    location: "Erg Chebbi · Merzouga",
    region: "Boutique Riad with Dune Views",
    region_fr: "Riad boutique avec vue sur les dunes",
    region_es: "Riad boutique con vistas a las dunas",
    image:
      "https://images.unsplash.com/photo-1539020140153-e479b8c22e70?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1539020140153-e479b8c22e70?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80",
      "https://images.unsplash.com/photo-1570133435536-7ececf000ef6?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80",
    ],
    intro: {
      en: "An intimate riad where Moroccan craftsmanship meets the silence of Erg Chebbi.",
      fr: "Un riad intime où l'artisanat marocain rencontre le silence de l'Erg Chebbi.",
      es: "Un riad íntimo donde la artesanía marroquí se encuentra con el silencio del Erg Chebbi.",
    },
    amenities: ["Patio", "Tea ritual", "Restaurant", "Library", "Bespoke excursions"],
  },
  {
    slug: "hotel-xaluca-spa-aguelmame-sidi-ali",
    category: "hotel",
    name: "Hotel Xaluca Spa Aguelmame Sidi Ali",
    location: "Lake Aguelmame Sidi Ali",
    region: "High Atlas Lakeside Retreat",
    region_fr: "Retraite lacustre dans le Haut Atlas",
    region_es: "Retiro junto al lago del Alto Atlas",
    image:
      "https://images.pexels.com/photos/35771005/pexels-photo-35771005.jpeg?auto=compress&cs=tinysrgb&w=1600",
    gallery: [
      "https://images.pexels.com/photos/35771005/pexels-photo-35771005.jpeg?auto=compress&cs=tinysrgb&w=1600",
    ],
    intro: {
      en: "A renovated mountain refuge, heated pool and spa overlooking a serene Atlas lake.",
      fr: "Un refuge de montagne rénové, piscine chauffée et spa surplombant un lac serein de l'Atlas.",
      es: "Un refugio de montaña renovado, piscina climatizada y spa con vistas a un sereno lago del Atlas.",
    },
    amenities: ["Heated pool", "Spa", "Lake views", "Trekking", "Berber cuisine"],
  },
  {
    slug: "xaluca-ifess-fess-refuge",
    category: "refuge",
    name: "Xaluca Ifess Fess Refuge de Montagne",
    location: "M'Goun Valley",
    region: "High-Mountain Hideaway",
    region_fr: "Refuge de haute montagne",
    region_es: "Refugio de alta montaña",
    image:
      "https://static.prod-images.emergentagent.com/jobs/4e06df6f-9a63-48ff-b8e2-384249cc96cb/images/3ef3804f701debb6deb08b44c397ef614c4c4d52fd2e912b5f5cbb24b2b0703e.png",
    gallery: [
      "https://static.prod-images.emergentagent.com/jobs/4e06df6f-9a63-48ff-b8e2-384249cc96cb/images/3ef3804f701debb6deb08b44c397ef614c4c4d52fd2e912b5f5cbb24b2b0703e.png",
    ],
    intro: {
      en: "Hidden among M'Goun canyons. Accessible by mule or on foot. Authentic Amazigh cuisine.",
      fr: "Caché parmi les canyons du M'Goun. Accessible à dos de mule ou à pied. Cuisine amazighe authentique.",
      es: "Escondido entre los cañones del M'Goun. Accesible en mula o a pie. Cocina amazigh auténtica.",
    },
    amenities: ["Trekking base", "Shared rooms", "Amazigh cuisine", "Canyon access"],
  },
  {
    slug: "auberge-la-belle-etoile",
    category: "bivouac",
    name: "Auberge La Belle Étoile",
    location: "Erg Chebbi · Merzouga",
    region: "Authentic Desert Auberge",
    region_fr: "Auberge authentique du désert",
    region_es: "Albergue auténtico del desierto",
    image:
      "https://images.pexels.com/photos/35771005/pexels-photo-35771005.jpeg?auto=compress&cs=tinysrgb&w=1600",
    gallery: [
      "https://images.pexels.com/photos/35771005/pexels-photo-35771005.jpeg?auto=compress&cs=tinysrgb&w=1600",
    ],
    intro: {
      en: "Sleep like a nomad beneath an infinite starry sky and chase the sunrises of Erg Chebbi.",
      fr: "Dormez comme un nomade sous un ciel infini et chassez les levers de soleil de l'Erg Chebbi.",
      es: "Duerma como un nómada bajo un cielo infinito y persiga los amaneceres del Erg Chebbi.",
    },
    amenities: ["Stargazing", "Sunrise rides", "Berber dinner", "Local guides"],
  },
  {
    slug: "xaluca-ait-ben-haddou",
    category: "hotel",
    bookable: false, // showcased on the site but not sold in the booking widget
    name: "Xaluca Aït Ben Haddou Maison d'Hôte",
    location: "Aït Ben Haddou · Ouarzazate",
    region: "UNESCO Fortified Village",
    region_fr: "Village fortifié classé UNESCO",
    region_es: "Pueblo fortificado UNESCO",
    image:
      "https://images.unsplash.com/photo-1570133435536-7ececf000ef6?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1570133435536-7ececf000ef6?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80",
    ],
    intro: {
      en: "A treasure hunt in the fortified UNESCO town. New maison d'hôte opening soon.",
      fr: "Une chasse au trésor dans la cité fortifiée classée UNESCO. Nouvelle maison d'hôte, ouverture prochaine.",
      es: "Una caza del tesoro en el pueblo fortificado UNESCO. Nueva casa de huéspedes, próxima apertura.",
    },
    amenities: ["UNESCO heritage", "Rooftop terraces", "Berber breakfast", "Guided walks"],
    coming_soon: true,
  },
  {
    slug: "hotel-xaluca-midelt",
    category: "hotel",
    bookable: false, // showcased on the site but not sold in the booking widget
    name: "Hotel Xaluca Midelt",
    location: "Midelt · Middle Atlas",
    region: "High-Mountain Sustainable Hotel",
    region_fr: "Hôtel de haute montagne durable",
    region_es: "Hotel de alta montaña sostenible",
    image:
      "https://images.pexels.com/photos/35771005/pexels-photo-35771005.jpeg?auto=compress&cs=tinysrgb&w=1600",
    gallery: [
      "https://images.pexels.com/photos/35771005/pexels-photo-35771005.jpeg?auto=compress&cs=tinysrgb&w=1600",
    ],
    intro: {
      en: "Upcoming high-mountain hotel project in the Atlas region, focused on sustainable and local development.",
      fr: "Futur hôtel de haute montagne dans la région de l'Atlas, axé sur le développement durable et local.",
      es: "Próximo proyecto hotelero de alta montaña en la región del Atlas, centrado en el desarrollo sostenible y local.",
    },
    amenities: ["Sustainable design", "Mountain views", "Local materials", "Apple orchards", "Trekking"],
    coming_soon: true,
  },
  {
    slug: "hotel-xaluca-dunes",
    category: "hotel",
    bookable: false, // showcased on the site but not sold in the booking widget
    name: "Hotel Xaluca Dunes",
    location: "Erg Chebbi · Merzouga",
    region: "5★ Luxury Within the Dunes",
    region_fr: "Luxe 5★ au cœur des dunes",
    region_es: "Lujo 5★ en el corazón de las dunas",
    image:
      "https://images.pexels.com/photos/30374217/pexels-photo-30374217.jpeg?auto=compress&cs=tinysrgb&w=1600",
    gallery: [
      "https://images.pexels.com/photos/30374217/pexels-photo-30374217.jpeg?auto=compress&cs=tinysrgb&w=1600",
    ],
    intro: {
      en: "Upcoming luxury 5-star desert hotel project planned directly within the Erg Chebbi dunes.",
      fr: "Futur hôtel 5 étoiles de luxe, conçu au cœur même des dunes de l'Erg Chebbi.",
      es: "Próximo hotel de lujo 5 estrellas, proyectado directamente entre las dunas del Erg Chebbi.",
    },
    amenities: ["5-star luxury", "Dune-front suites", "Private pools", "Bespoke concierge", "Helipad"],
    coming_soon: true,
  },
  {
    slug: "la-belle-etoile-bivouacs",
    category: "bivouac",
    name: "La Belle Étoile Bivouacs",
    location: "Erg Chebbi · Merzouga",
    region: "Under the Saharan stars",
    region_fr: "Sous les étoiles du Sahara",
    region_es: "Bajo las estrellas del Sáhara",
    image:
      "https://images.pexels.com/photos/30374217/pexels-photo-30374217.jpeg?auto=compress&cs=tinysrgb&w=1600",
    gallery: [
      "https://images.pexels.com/photos/30374217/pexels-photo-30374217.jpeg?auto=compress&cs=tinysrgb&w=1600",
      "https://images.pexels.com/photos/35771005/pexels-photo-35771005.jpeg?auto=compress&cs=tinysrgb&w=1600",
      "https://images.unsplash.com/photo-1473580044384-7ba9967e16a0?auto=format&fit=crop&w=1600&q=80",
      "https://images.unsplash.com/photo-1547234935-80c7145ec969?auto=format&fit=crop&w=1600&q=80",
    ],
    intro: {
      en: "Pitched deep inside the Erg Chebbi dunes — Berber haimas, embroidered cushions, lanterns and a sky so dense with stars it earns the camp its name.",
      fr: "Implanté au cœur des dunes de l'Erg Chebbi — haimas berbères, coussins brodés, lanternes et un ciel si dense d'étoiles qu'il donne son nom au camp.",
      es: "Plantado en el corazón de las dunas del Erg Chebbi — haimas bereberes, cojines bordados, faroles y un cielo tan denso de estrellas que da nombre al campamento.",
    },
    amenities: ["Private haimas", "Mechoui dinner", "Stargazing", "Camel rides", "Berber music"],
  },
  {
    slug: "kamkamia-luxury-desert-camp",
    category: "bivouac",
    name: "Kamkamia Luxury Desert Camp",
    location: "Erg Chebbi · Merzouga",
    region: "5-star bivouac in the dunes",
    region_fr: "Bivouac 5 étoiles dans les dunes",
    region_es: "Vivac 5 estrellas en las dunas",
    image:
      "https://images.pexels.com/photos/35771005/pexels-photo-35771005.jpeg?auto=compress&cs=tinysrgb&w=1600",
    gallery: [
      "https://images.pexels.com/photos/35771005/pexels-photo-35771005.jpeg?auto=compress&cs=tinysrgb&w=1600",
      "https://images.pexels.com/photos/30374217/pexels-photo-30374217.jpeg?auto=compress&cs=tinysrgb&w=1600",
      "https://images.unsplash.com/photo-1547234935-80c7145ec969?auto=format&fit=crop&w=1600&q=80",
      "https://images.unsplash.com/photo-1473580044384-7ba9967e16a0?auto=format&fit=crop&w=1600&q=80",
    ],
    intro: {
      en: "Our most refined desert camp — private suite tents with king beds, en-suite bathrooms, copper basins and a candle-lit dining tent set among the highest dunes.",
      fr: "Notre camp du désert le plus raffiné — tentes-suites privées avec lits king, salles de bain en suite, vasques en cuivre et tente-restaurant aux chandelles parmi les plus hautes dunes.",
      es: "Nuestro campamento del desierto más refinado — tiendas-suite privadas con cama king, baños en suite, lavabos de cobre y tienda comedor a la luz de las velas entre las dunas más altas.",
    },
    amenities: ["Suite tents", "En-suite bathrooms", "Gourmet dinner", "Sunrise terrace", "Private bar"],
  },
  {
    slug: "merdani-bivouac",
    category: "bivouac",
    name: "Merdani Bivouac",
    location: "Merdani · pre-Sahara plateau",
    region: "Off-the-beaten-path desert camp",
    region_fr: "Camp désertique hors des sentiers battus",
    region_es: "Vivac del desierto fuera de las rutas",
    image:
      "https://images.unsplash.com/photo-1547234935-80c7145ec969?auto=format&fit=crop&w=1600&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1547234935-80c7145ec969?auto=format&fit=crop&w=1600&q=80",
      "https://images.pexels.com/photos/30374217/pexels-photo-30374217.jpeg?auto=compress&cs=tinysrgb&w=1600",
      "https://images.pexels.com/photos/35771005/pexels-photo-35771005.jpeg?auto=compress&cs=tinysrgb&w=1600",
      "https://images.unsplash.com/photo-1473580044384-7ba9967e16a0?auto=format&fit=crop&w=1600&q=80",
    ],
    intro: {
      en: "A quieter alternative to Erg Chebbi — set on the Merdani plateau where black-stone hammada meets rolling dunes. Small, intimate, perfect for stargazers and writers.",
      fr: "Une alternative plus paisible à l'Erg Chebbi — sur le plateau de Merdani où la hamada de pierres noires rencontre les dunes ondulées. Petit, intime, idéal pour les astronomes et les auteurs.",
      es: "Una alternativa más tranquila al Erg Chebbi — sobre la meseta de Merdani, donde la hamada de piedras negras se encuentra con las dunas onduladas. Pequeño, íntimo, ideal para astrónomos y escritores.",
    },
    amenities: ["Small camp", "Hammada landscape", "Astronomy guide", "Quiet retreat", "4x4 access"],
  },
];

export const EXPERIENCES = [
  {
    key: "desert",
    image:
      "https://static.prod-images.emergentagent.com/jobs/4e06df6f-9a63-48ff-b8e2-384249cc96cb/images/e83d1b02b43f9070b09fb3b7b908378a50bddd3ed4f1e24e803d7ff982298077.png",
    title: { en: "Sahara Camel Caravans", fr: "Caravanes de chameaux du Sahara", es: "Caravanas de camellos del Sáhara" },
    desc: {
      en: "Cross the golden dunes of Erg Chebbi at dusk and bivouac under the Milky Way.",
      fr: "Traversez les dunes dorées de l'Erg Chebbi au crépuscule et bivouaquez sous la Voie lactée.",
      es: "Cruce las dunas doradas del Erg Chebbi al atardecer y vivaquee bajo la Vía Láctea.",
    },
  },
  {
    key: "atlas",
    image:
      "https://images.pexels.com/photos/35771005/pexels-photo-35771005.jpeg?auto=compress&cs=tinysrgb&w=1600",
    title: { en: "Atlas Mountain Treks", fr: "Treks dans l'Atlas", es: "Caminatas por el Atlas" },
    desc: {
      en: "Hike the rugged Atlas with Berber guides, sharing tea in nomad tents.",
      fr: "Randonnez dans l'Atlas escarpé avec des guides berbères, autour d'un thé sous tente nomade.",
      es: "Camine por el Atlas escarpado con guías bereberes y comparta té en tiendas nómadas.",
    },
  },
  {
    key: "kasbah",
    image:
      "https://images.unsplash.com/photo-1570133435536-7ececf000ef6?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80",
    title: { en: "Kasbah Heritage Trails", fr: "Sentiers du patrimoine des kasbahs", es: "Rutas del patrimonio kasbah" },
    desc: {
      en: "Walk fortified earthen villages and discover the artistry of mud-brick architecture.",
      fr: "Parcourez des villages fortifiés en terre et découvrez l'art de l'architecture en pisé.",
      es: "Recorra aldeas fortificadas de tierra y descubra el arte de la arquitectura de adobe.",
    },
  },
  {
    key: "berber",
    image:
      "https://images.unsplash.com/photo-1539020140153-e479b8c22e70?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80",
    title: { en: "Berber Living Heritage", fr: "Patrimoine vivant berbère", es: "Patrimonio vivo bereber" },
    desc: {
      en: "Weaving, music, gnaoua rhythms — share a slow afternoon with the families behind the craft.",
      fr: "Tissage, musique, rythmes gnaoua — partagez un après-midi lent avec les familles d'artisans.",
      es: "Tejido, música, ritmos gnaoua — comparta una tarde con las familias artesanas.",
    },
  },
  // ── Xaluca Originals ─────────────────────────────────────────────────
  // Shorter, more activity-style add-ons. The `secondary: true` flag tells the
  // /experiences page to render these inside the horizontal carousel rather
  // than the editorial grid above. Each still has a full /experiences/:key page.
  {
    key: "sunrise-camel-trek",
    secondary: true,
    image:
      "https://images.unsplash.com/photo-1473580044384-7ba9967e16a0?auto=format&fit=crop&w=1600&q=80",
    title: {
      en: "Sunrise Camel Trek & Erg Chebbi Discovery",
      fr: "Caravane à l'aube & découverte de l'Erg Chebbi",
      es: "Caravana al amanecer y descubrimiento del Erg Chebbi",
    },
    desc: {
      en: "Sahara magic at sunrise — 4x4 transfer from your hotel, then a camel caravan to a private viewpoint over the dunes.",
      fr: "Le Sahara magique à l'aube — transfert 4x4 depuis l'hôtel, puis caravane à dos de dromadaire vers un point de vue privilégié.",
      es: "La magia del Sáhara al amanecer — traslado en 4x4 desde el hotel y caravana a un mirador privilegiado sobre las dunas.",
    },
  },
  {
    key: "sunset-camel-trek",
    secondary: true,
    image:
      "https://images.unsplash.com/photo-1542401886-65d6c61db217?auto=format&fit=crop&w=1600&q=80",
    title: {
      en: "Sunset Camel Trek & Erg Chebbi Discovery",
      fr: "Caravane au coucher du soleil & découverte de l'Erg Chebbi",
      es: "Caravana al atardecer y descubrimiento del Erg Chebbi",
    },
    desc: {
      en: "Watch the Erg Chebbi turn from copper to rose. Hotel pickup, 4x4 to the dunes, then a camel ride to a sunset vantage point.",
      fr: "Voyez l'Erg Chebbi virer du cuivre au rose. Prise en charge à l'hôtel, 4x4 jusqu'aux dunes, puis dromadaire jusqu'à un belvédère au coucher du soleil.",
      es: "Vea el Erg Chebbi pasar del cobre al rosa. Recogida en el hotel, 4x4 a las dunas y paseo en camello hasta un mirador al atardecer.",
    },
  },
  {
    key: "arfoud-pizza-night",
    secondary: true,
    image:
      "https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?auto=format&fit=crop&w=1600&q=80",
    title: {
      en: "Pizza Night in Arfoud",
      fr: "Soirée pizza à Arfoud",
      es: "Noche de pizza en Arfoud",
    },
    desc: {
      en: "A relaxed lunch or dinner at one of Arfoud's most renowned pizzerias — casual atmosphere, a local favourite, easy on the family.",
      fr: "Un déjeuner ou dîner décontracté dans l'une des pizzerias les plus réputées d'Arfoud — ambiance simple, table locale, idéale en famille.",
      es: "Un almuerzo o cena relajada en una de las pizzerías más renombradas de Arfoud — ambiente casual, mesa local, ideal en familia.",
    },
  },
  {
    key: "quad-erg-chebbi-2h",
    secondary: true,
    image:
      "https://images.unsplash.com/photo-1532274402911-5a369e4c4bb5?auto=format&fit=crop&w=1600&q=80",
    title: {
      en: "Erg Chebbi Quad Adventure — 2 Hours",
      fr: "Aventure quad Erg Chebbi — 2 heures",
      es: "Aventura en quad por Erg Chebbi — 2 horas",
    },
    desc: {
      en: "Two hours of pure dune thrill — desert tracks, hidden viewpoints and experienced local guides. Open to beginners and pros.",
      fr: "Deux heures de pur frisson dans les dunes — pistes du désert, points de vue cachés et guides locaux expérimentés. Pour débutants et confirmés.",
      es: "Dos horas de pura adrenalina entre las dunas — pistas del desierto, miradores escondidos y guías locales experimentados. Para principiantes y expertos.",
    },
  },
  {
    key: "quad-erg-chebbi-4h",
    secondary: true,
    image:
      "https://images.unsplash.com/photo-1530541930197-ff16ac917b0e?auto=format&fit=crop&w=1600&q=80",
    title: {
      en: "Erg Chebbi Quad Adventure — 4 Hours",
      fr: "Aventure quad Erg Chebbi — 4 heures",
      es: "Aventura en quad por Erg Chebbi — 4 horas",
    },
    desc: {
      en: "A longer, more immersive ride deep into the Sahara — remote landscapes, hidden ksour and the freedom of the open desert.",
      fr: "Une virée plus longue et immersive au cœur du Sahara — paysages reculés, ksour cachés et la liberté du grand désert.",
      es: "Una salida más larga e inmersiva en pleno Sáhara — paisajes remotos, ksures escondidos y la libertad del gran desierto.",
    },
  },
];

export const TESTIMONIALS = [
  {
    name: "Sophie M.",
    place: "Paris, France",
    travel_type: { en: "Family trip", fr: "Voyage en famille", es: "Viaje en familia" },
    text: {
      en: "An extraordinary stay. Grup Xaluca turned a corporate event into a once-in-a-lifetime memory.",
      fr: "Un séjour extraordinaire. Grup Xaluca a transformé un événement d'entreprise en souvenir inoubliable.",
      es: "Una estancia extraordinaria. Grup Xaluca convirtió un evento corporativo en un recuerdo inolvidable.",
    },
  },
  {
    name: "Carlos R.",
    place: "Madrid, España",
    travel_type: { en: "Honeymoon", fr: "Lune de miel", es: "Luna de miel" },
    text: {
      en: "The bivouac under the Erg Chebbi sky is something every traveler must experience once.",
      fr: "Le bivouac sous le ciel de l'Erg Chebbi est une expérience à vivre absolument.",
      es: "El vivac bajo el cielo del Erg Chebbi es algo que todo viajero debe vivir una vez.",
    },
  },
  {
    name: "Aiko T.",
    place: "Tokyo, Japan",
    travel_type: { en: "Solo journey", fr: "Voyage en solo", es: "Viaje en solitario" },
    text: {
      en: "Warm hospitality, refined detail, and a deep sense of place. Truly the soul of southern Morocco.",
      fr: "Une hospitalité chaleureuse, un raffinement du détail et un véritable sens du lieu. L'âme du sud marocain.",
      es: "Hospitalidad cálida, detalle refinado y un profundo sentido del lugar. El alma del sur de Marruecos.",
    },
  },
  {
    name: "Maximilian K.",
    place: "Berlin, Deutschland",
    travel_type: { en: "Photo expedition", fr: "Expédition photo", es: "Expedición fotográfica" },
    text: {
      en: "Every meal told a story — and every guide remembered our names. The south of Morocco felt like coming home to a family we had only just met.",
      fr: "Chaque repas racontait une histoire — et chaque guide se souvenait de nos prénoms. Le sud marocain a eu le goût d'un retour chez une famille que l'on venait à peine de rencontrer.",
      es: "Cada comida contaba una historia — y cada guía recordaba nuestros nombres. El sur de Marruecos se sintió como volver a casa de una familia que apenas acabábamos de conocer.",
    },
  },
  {
    name: "Lena B.",
    place: "Stockholm, Sverige",
    travel_type: { en: "Wellness retreat", fr: "Retraite bien-être", es: "Retiro de bienestar" },
    text: {
      en: "The silence at sunrise on the dune, the mint tea poured three times, the kindness of the staff — small details that turn a trip into a transformation.",
      fr: "Le silence à l'aube sur la dune, le thé à la menthe servi trois fois, la gentillesse des équipes — des petits détails qui transforment un voyage en métamorphose.",
      es: "El silencio al amanecer en la duna, el té con menta servido tres veces, la amabilidad del equipo: pequeños detalles que convierten un viaje en una transformación.",
    },
  },
  {
    name: "Diego L.",
    place: "Buenos Aires, Argentina",
    travel_type: { en: "Adventure", fr: "Aventure", es: "Aventura" },
    text: {
      en: "From the High Atlas refuge to the campfire in the Sahara, the team made every transition feel effortless. The route itself is a masterpiece.",
      fr: "Du refuge du Haut Atlas au feu de camp au Sahara, l'équipe a rendu chaque transition fluide. L'itinéraire lui-même est un chef-d'œuvre.",
      es: "Del refugio del Alto Atlas al fuego de campamento en el Sáhara, el equipo hizo que cada transición fuera fluida. El propio itinerario es una obra maestra.",
    },
  },
];

export const HERO_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/4e06df6f-9a63-48ff-b8e2-384249cc96cb/images/3ef3804f701debb6deb08b44c397ef614c4c4d52fd2e912b5f5cbb24b2b0703e.png";

export const GASTRONOMY_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/4e06df6f-9a63-48ff-b8e2-384249cc96cb/images/60295e81208ff76ed6b6281687581975b95ca31aecd115f5f37ece444fa3eb52.png";

export const EXCURSION_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/4e06df6f-9a63-48ff-b8e2-384249cc96cb/images/e83d1b02b43f9070b09fb3b7b908378a50bddd3ed4f1e24e803d7ff982298077.png";
